
/*
 *   File : file-selector.js
 *   Author : https://evoqins.com
 *   Description : FileSelector component
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React from 'react';
import { FileUploader } from 'react-drag-drop-files';
import { Icon } from '../Icon';

// custom styles
import style from '../../Style//Component/file-selector.module.scss';


const FileSelector = (props) => {

    return (
        <div className={props.className}>
            <label className={`e-text-chinese-black d-flex justify-content-between align-items-center e-font-14 e-primary-font e-font-weight-400 line-height-18px padding-4px-bottom`}>

                <div> {props.title}
                    {props.required &&
                        <span className='e-text-carmine-pink'>*</span>
                    }
                </div>

                {/* <div className='cursor-pointer e-font-14 e-primary-font line-height-16px e-font-weight-600 e-text-blue-violet'>{props.downloadTitle}</div> */}
            </label>
            {props.type === 1 ?
                <div className={`margin-24px-bottom ${style.file_selector}`}>
                    {props.value ? (
                        <div className={`${style.e_file} ${props.height ? props.height : ""} ${props.error ? 'e-border-0-5px-carmine-pink-dashed ' : 'e-border-0-5px-arsenic-dashed '}     overflow-hidden z-0
                                     d-flex align-items-center position-relative justify-content-center flex-column text-center cursor-pointer`}>
                            <div className={` z-2 px-2 padding-20px-tb border-radius-4  ${props.value === null && 'e-bg-light-lavender '}`}>
                                {props.value === null ?
                                    <>
                                        <Icon icon="upload"
                                            size={16}
                                            className="margin-8px-bottom" />
                                        <p className="e-primary-font e-font-14 line-height-16px e-text-blue-violet mb-0">Choose file <span className="e-text-chinese-black">or drop here</span></p>
                                    </>
                                    :
                                    props.fileDetails &&
                                    <p className=' mb-0 cursor-pointer e-font-14 e-primary-font line-height-16px e-font-weight-600 e-text-blue-violet'>{props.fileDetails.file}</p>
                                }
                            </div>

                            {props.value &&
                                <div className=' position-absolute e-bg-lavender  z-0 left-0 top-0 right-0 bottom-0 m-auto w-100 h- d-flex flex-column justify-content-center'>
                                    {props.fileType.includes("PNG") &&
                                        <img className='object-fit-contain'
                                            src={props.value}
                                            alt='file' />
                                    }

                                    <div>
                                        <Icon size='1rem'
                                            icon='close'
                                            className='position-absolute right-16px top-16px  z-3 '
                                            onClick={props.handleClose} />
                                    </div>
                                </div>
                            }
                        </div>
                    ) : (
                        <FileUploader name="file"
                            multiple={false}
                            types={props.fileType}
                            handleChange={props.handleChange}
                            children={
                                <div className=" ">
                                    {
                                        <div className={`${style.e_file} ${props.height ? props.height : ""} ${props.error ? 'e-border-0-5px-carmine-pink-dashed ' : 'e-border-0-5px-arsenic-dashed '} e-bg-white overflow-hidden z-0
                                     d-flex align-items-center position-relative justify-content-center flex-column text-center cursor-pointer`}>
                                            <div className={` z-2 padding-8px-all border-radius-4 ${props.value && 'e-bg-light-lavender '}`}>
                                                {props.loader ?
                                                    <img src={require("../../Assets/Image/loader.gif")}
                                                        draggable={false}
                                                        width={42}
                                                        height={42}
                                                        alt='loader' />
                                                    :

                                                    props.value === null ?
                                                        <>
                                                            <Icon icon="upload"
                                                                size={16}
                                                                className="margin-8px-bottom" />
                                                            <p className="e-primary-font e-font-14 line-height-16px e-text-blue-violet mb-0">Choose file <span className="e-text-chinese-black">or drop here</span></p>
                                                        </>
                                                        :
                                                        <p>file name</p>

                                                }
                                            </div>

                                            {props.value &&
                                                <div className=' position-absolute z-1 left-0 top-0 right-0 bottom-0 m-auto w-100 '>
                                                    <img className='w-100 h-100'
                                                        src={props.value} />
                                                    <div>
                                                        <Icon size='1rem'
                                                            icon='close'
                                                            className='position-absolute right-16px top-16px  z-3 '
                                                            onClick={props.handleClose} />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }

                                </div>
                            }
                        />
                    )}

                    <div className={` d-flex  justify-content-between mt-1 ${props.primeDataClass ? props.primeDataClass : "align-items-center"}`}>
                        <div className='e-primary-font e-font-14 line-height-18px e-font-weight-400 e-text-quick-silver pb-1'>{props.primeData ? props.primeData : 'File supported:PNG'}</div>
                        <div className='e-primary-font e-font-14 line-height-18px e-font-weight-400 e-text-quick-silver pb-1'>{props.primeDataSize ? props.primeDataSize : 'Maximum file size: 10 MB'}</div>
                    </div>

                    {props.error &&
                        <p className={`position-absolute mb-0 e-text-carmine-pink e-primary-font e-font-12 line-height-12px  e-font-weight-500`}>
                            {props.error}
                        </p>
                    }
                </div>
                :

                <div className={`${style.file_selector_two}`}>
                    {props.value ? (
                        <div className="position-relative">
                            <div className={`${style.e_image_file} e-border-0-5px-arsenic-dashed e-bg-lavender overflow-hidden z-4 d-flex align-items-center position-relative justify-content-center flex-column text-center`}>
                                <div className='d-flex align-items-center justify-content-center '>
                                    <p className="e-primary-font position-absolute e-bg-light-lavender border-radius-4 py-3  e-font-14 line-height-16px e-text-blue-violet mb-0 text-center">
                                        Choose file <br /> <span className="e-text-chinese-black">or drop here</span>
                                    </p>
                                    <img
                                        className="w-100  object-fit-contain"
                                        src={props.value}
                                        alt="Selected file"
                                    />
                                    <Icon size="1rem"
                                        icon="close"
                                        className="position-absolute right-4px top-4px cursor-pointer"
                                        onClick={props.handleClose}
                                    />

                                </div>
                            </div>
                        </div>
                    ) : (
                        <FileUploader
                            name="file"
                            multiple={false}
                            types={props.fileType}
                            handleChange={props.handleChange}
                            children={
                                <div className="position-relative">
                                    <div
                                        className={`${style.e_file} ${props.error
                                            ? 'e-border-0-5px-carmine-pink-dashed'
                                            : 'e-border-0-5px-arsenic-dashed'
                                            } overflow-hidden z-1 d-flex align-items-center position-relative justify-content-center flex-column text-center cursor-pointer`}
                                    >
                                        <div className={`z-2 padding-8px-all border-radius-4`}>
                                            <Icon
                                                icon="upload"
                                                size={16}
                                                className="margin-8px-bottom"
                                            />
                                            <p className="e-primary-font e-font-14 line-height-16px e-text-blue-violet mb-0">
                                                Choose file <span className="e-text-chinese-black">or drop here</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            }
                        />
                    )}

                    <div className="mt-1">
                        <div className="e-primary-font e-font-14 line-height-18px e-font-weight-400 e-text-quick-silver pb-1">
                            File supported: PNG
                        </div>
                        <div className="e-primary-font e-font-14 line-height-18px e-font-weight-400 e-text-quick-silver pb-1">
                            Maximum file size: 10 MB
                        </div>
                    </div>

                    {props.error && (
                        <p className="position-absolute mb-0 e-text-carmine-pink e-primary-font e-font-12 line-height-12px e-font-weight-500">
                            {props.error}
                        </p>
                    )}
                </div>


            }
        </div >
    )
}

export default FileSelector;